import { FormattedMessage, IntlProvider } from 'react-intl';
import React, { useEffect } from 'react';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import { getAmplitudeInstance } from '@alltrails/shared/utils/amplitudeHelpers';
import { logExploreWithProButtonClicked, logProWelcomePageViewed } from 'utils/constants/AmplitudeEvent';
import AnchorButton from 'components/AnchorButton';
import * as styles from './styles.module.scss';

const {
  FOR_THE_BEST_EXPERIENCE,
  START_EXPLORING_WITH_PRO,
  WELCOME_TO,
  YOU_RE_AN_OFFICIAL_PRO_SUBSCRIBER,
  WELCOME_TO_OUR_COMMUNITY_OF_OUTDOOR_ENTHUSIASTS_JUST_LIKE_YOU
} = StringConstantsMixin.strings;

function ProWelcome() {
  useEffect(() => {
    logProWelcomePageViewed();
  }, []);

  // could be a shared function
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  return (
    <IntlProvider locale="en">
      <div className={styles.proWelcome}>
        <section>
          <div className={styles.welcomeText}>
            <h1 className={styles.heading}>
              <FormattedMessage defaultMessage={WELCOME_TO} id={WELCOME_TO} values={{ pro: <span className={styles.welcomeProBadge} /> }} />
            </h1>
            <p className={styles.welcome}>
              {YOU_RE_AN_OFFICIAL_PRO_SUBSCRIBER}
              <br />
              {WELCOME_TO_OUR_COMMUNITY_OF_OUTDOOR_ENTHUSIASTS_JUST_LIKE_YOU}
            </p>
            {isMobile ? (
              <p className={styles.mobile}>{FOR_THE_BEST_EXPERIENCE}</p>
            ) : (
              <AnchorButton
                href="/explore?ref=pro-welcome"
                onClick={() => {
                  logExploreWithProButtonClicked();
                }}
              >
                {START_EXPLORING_WITH_PRO}
              </AnchorButton>
            )}
          </div>
          <div className={styles.topImage} />
        </section>
      </div>
    </IntlProvider>
  );
}

export default ProWelcome;
